import { getCurrencyRequestRpc } from 'growth-monetization-service-types';
import { rpcClient } from '../../rpcClient';
export const fetchCurrency = () => {
  const fallbackCurrencyCode = 'USD';
  return rpcClient.call(getCurrencyRequestRpc, {}).then(currencyResponse => {
    var _ref, _currencyResponse$loc;
    return (_ref = (_currencyResponse$loc = currencyResponse.lockedCurrencyCode) !== null && _currencyResponse$loc !== void 0 ? _currencyResponse$loc : currencyResponse.defaultCurrencyCode) !== null && _ref !== void 0 ? _ref : fallbackCurrencyCode;
  }, error => {
    console.error('Failed to fetch currency', error);
    return fallbackCurrencyCode;
  });
};